var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('v-main',{staticClass:"bg"},[_c('router-view',{staticClass:"main"})],1),_c('vue-progress-bar'),_c('v-overlay',{attrs:{"value":_vm.$store.state.showOverlay,"opacity":"0.2","z-index":9999}},[_c('v-progress-circular',{attrs:{"indeterminate":"","size":"65","width":7,"color":"button"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }